import React from "react";
import { PublishCode } from "../../types";

interface PublishModalProps {
	publishedCode: PublishCode;
	onClose: () => void;
}

const PublishModal: React.FC<PublishModalProps> = ({
	publishedCode,
	onClose,
}) => {
	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white rounded-lg p-4 max-w-4xl w-full max-h-[90vh] overflow-auto">
				<div className="flex justify-between items-center mb-4">
					<h2 className="text-xl font-bold">Published Code</h2>
					<button
						className="p-1 rounded-full hover:bg-gray-100"
						onClick={onClose}>
						❌
					</button>
				</div>

				<div className="mb-4">
					<h3 className="font-semibold mb-2">HTML:</h3>
					<pre className="p-4 bg-gray-100 rounded overflow-auto text-sm max-h-[30vh]">
						{publishedCode.html}
					</pre>
				</div>

				<div className="mb-4">
					<h3 className="font-semibold mb-2">CSS:</h3>
					<pre className="p-4 bg-gray-100 rounded overflow-auto text-sm max-h-[30vh]">
						{publishedCode.css}
					</pre>
				</div>

				<div className="flex justify-end">
					<button
						className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 mr-2"
						onClick={() => {
							// Copy HTML to clipboard
							navigator.clipboard.writeText(publishedCode.html);
							alert("HTML copied to clipboard!");
						}}>
						Copy HTML
					</button>
					<button
						className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
						onClick={() => {
							// Copy CSS to clipboard
							navigator.clipboard.writeText(publishedCode.css);
							alert("CSS copied to clipboard!");
						}}>
						Copy CSS
					</button>
				</div>
			</div>
		</div>
	);
};

export default PublishModal;
